import React, { useEffect, useRef, useState } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer } from 'antd';
import {TypesOfValueAddition2Dto} from '@gtpl/shared-models/masters';
import {TypesOfValueAddition2Service} from '@gtpl/shared-services/masters';
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import {TypeOfValueAddition2Form} from '@gtpl/pages/master/master-components/type-of-value-addition2-form'

import './type-of-value-addition2-grid.css';
import { Link } from 'react-router-dom';
import { UserRequestDto } from '@gtpl/shared-models/common-models';

/* eslint-disable-next-line */
export interface TypeOfValueAddition2GridProps {}

export function TypeOfValueAddition2Grid(props: TypeOfValueAddition2GridProps){
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [TypesOfValueAddition2Data, setTypesOfValueAddition2Data] = useState<TypesOfValueAddition2Dto[]>([]);
  const [selectedTypesOfValueAddition2Data, setSelectedTypesOfValueAddition2Data] = useState<any>(undefined);
  
  const TypesOfValueAddition2DataService=new TypesOfValueAddition2Service();

  useEffect(() => {
    getAllTypesOfValueAddition2s();
  }, []);

  /**
   * 
   */
  const getAllTypesOfValueAddition2s= () => {
    TypesOfValueAddition2DataService.getAllTypesOfValueAddition2s(new UserRequestDto(JSON.parse(localStorage.getItem('username')))).then(res => {
      if (res.status) {
        setTypesOfValueAddition2Data(res.data);
      } else {
        if (res.intlCode) {
            setTypesOfValueAddition2Data([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setTypesOfValueAddition2Data([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  /**
   * 
   * @param TypesOfValueAddition2Data 
   */
  const deleteTypesOfValueAddition2 = (TypesOfValueAddition2Data:TypesOfValueAddition2Dto) => {
    TypesOfValueAddition2Data.isActive=TypesOfValueAddition2Data.isActive?false:true;
    TypesOfValueAddition2DataService.activatedeActivateTypesOfValueAddition2(TypesOfValueAddition2Data).then(res => { console.log(res);
      if (res.status) {
        getAllTypesOfValueAddition2s();
        AlertMessages.getSuccessMessage('Success'); 
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }
   
    /**
     * 
     * @param variantData 
     */
    const updateTypesOfValueAddition2 = (TypesOfValueAddition2Data: TypesOfValueAddition2Dto) => {
      TypesOfValueAddition2Data.updatedUser= JSON.parse(localStorage.getItem('username'))
      TypesOfValueAddition2DataService.updateTypesOfValueAddition2(TypesOfValueAddition2Data).then(res => { console.log(res);
        if (res.status) {
          AlertMessages.getSuccessMessage('Updated Successfully');
          getAllTypesOfValueAddition2s();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }
   /**
   * used for column filter
   * @param dataIndex column data index
   */
  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

    //drawer related
    const closeDrawer=()=>{
      setDrawerVisible(false);
    }
  
    //TO open the form for updation
    const openFormWithData=(viewData: TypesOfValueAddition2Dto)=>{
      // console.log(viewData);
      
      setDrawerVisible(true);
      setSelectedTypesOfValueAddition2Data(viewData);
      // console.log(selectedTypesOfValueAddition2Data);
      
    }


  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: 'Name',
      dataIndex: 'name',
      // responsive: ['lg'],
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('name')
    },
    {
      title: 'Code',
      dataIndex: 'code',
      // responsive: ['lg'],
      sorter: (a, b) => a.code.localeCompare(b.code),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('code')
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      // responsive: ['lg'],
      responsive: ['sm'],
     
      ...getColumnSearchProps('remarks')
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        rowData.name.trim()=='NA' || rowData.name.trim()=='N/A' ? <span> </span>:
        <span>         
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                  openFormWithData(rowData);
                } else {
                  AlertMessages.getErrorMessage('You Cannot Edit Deactivated Value');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{deleteTypesOfValueAddition2(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Value Addition Two Data ?'
                :  'Are you sure to Activate Value Addition Two Data ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];

  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  return (
    <Card title={<span style={{color:'white'}}>Value Additions 2</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }}  extra={<Link to='/valueaddition2-form' ><span style={{color:'white'}} ><Button className='panel_button' >Create </Button> </span></Link>}  >
     <br></br>
     <Row gutter={40}>
      <Col>
          <Card title={'Total Value Additions: ' + TypesOfValueAddition2Data.length} style={{textAlign: 'left', width: 240, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + TypesOfValueAddition2Data.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active: ' + TypesOfValueAddition2Data.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.productId}
          columns={columnsSkelton}
          dataSource={TypesOfValueAddition2Data}
          scroll = {{x:true}}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <TypeOfValueAddition2Form key={Date.now()}
                updateTypesOfValueAddition2Dto={updateTypesOfValueAddition2}
                isUpdate={true}
                TypesOfValueAddition2Data={selectedTypesOfValueAddition2Data}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
     </Card>
  );
}

export default TypeOfValueAddition2Grid;
